import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import vehiclePropType from '../../../propTypes/vehiclePropType';
import CarouselContainer from '../mediaSection/CarouselContainer';
import DetailsContainer from '../detailsSection/DetailsContainer';
import FooterContainer from '../footerSection/FooterContainer';
import VehicleCardContainer from './common/VehicleCardContainer';

const ListCard = ({
	accounts,
	featuredPromotion,
	forwardedRef,
	incentives,
	inventoryIndex,
	setShowOffSite,
	shouldFullyRenderCard,
	vehicle,
	usePlaceholderImage
}) => {
	const canRender = shouldFullyRenderCard && !vehicle.isPlaceholder;
	const willRenderBlankPlaceholderImage =
		inventoryIndex === 0 && vehicle.isPlaceholder === true;

	const {
		uuid,
		link,
		images = [],
		featuredPromotion: featuredPromotionAttr = false,
		offSite,
		videos = [],
		title
	} = vehicle;

	const accountPhone = accounts?.[vehicle?.accountId]?.phone;

	useEffect(() => {
		import('./ListCard.scss');
	}, []);

	return (
		<VehicleCardContainer // Suggestion: added this so it's reuseable for GridCard
			inventoryIndex={inventoryIndex}
			setShowOffSite={setShowOffSite}
			isFeaturedPromotion={featuredPromotion || featuredPromotionAttr}
			isOffsite={offSite}
			forwardedRef={forwardedRef}
			layout="list"
			uuid={uuid}
		>
			<div className="vehicle-card-body ddc-font-size-small d-sm-flex flex-sm-row">
				<CarouselContainer
					images={images}
					shouldFullyRenderCard={shouldFullyRenderCard}
					willRenderBlankPlaceholderImage={
						willRenderBlankPlaceholderImage
					}
					link={link}
					uuid={uuid}
					videos={videos}
					title={title}
					phone={accountPhone}
					usePlaceholderImage={usePlaceholderImage}
				/>
				<div className="vehicle-details-wrapper">
					<DetailsContainer
						vehicle={vehicle}
						incentives={incentives}
						accounts={accounts}
						shouldFullyRenderCard={canRender}
					/>
					<FooterContainer
						vehicle={vehicle}
						uuid={uuid}
						link={link}
						shouldFullyRenderCard={canRender}
					/>
				</div>
			</div>
		</VehicleCardContainer>
	);
};

const WrappedListCard = React.forwardRef((props, ref) => {
	return <ListCard {...props} forwardedRef={ref} />;
});

WrappedListCard.displayName = 'ListCard';

ListCard.propTypes = {
	accounts: PropTypes.shape({}).isRequired,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	featuredPromotion: PropTypes.bool,
	incentives: PropTypes.shape({}).isRequired,
	inventoryIndex: PropTypes.number.isRequired,
	setShowOffSite: PropTypes.func,
	shouldFullyRenderCard: PropTypes.bool,
	vehicle: vehiclePropType.isRequired,
	usePlaceholderImage: PropTypes.bool
};

export default WrappedListCard;
